import dayjs from "dayjs";

import { patientIdFromReference } from "../aggregations";
import type { AppointmentPeriodBounds } from "./resolveAppointmentFetchDateRange";

function appointmentStartToIsoDate(start: string | undefined): string | null {
  if (!start?.trim()) return null;
  const parsed = dayjs(start);
  if (!parsed.isValid()) return null;
  return parsed.format("YYYY-MM-DD");
}

function isAppointmentDateWithinPeriod(
  isoDate: string,
  period: AppointmentPeriodBounds,
): boolean {
  const from = period.from?.trim() || null;
  const to = period.to?.trim() || null;
  if (from && isoDate < from) return false;
  if (to && isoDate > to) return false;
  return true;
}

/**
 * Pacientes com pelo menos uma consulta fulfilled cuja data (`start`) cai no período
 * informado pelo usuário (respeitando limites opcionais de início e fim).
 */
export function derivePatientIdsAttendedInPeriod(
  bundle: fhir5.Bundle | undefined,
  period: AppointmentPeriodBounds,
): Set<string> {
  const ids = new Set<string>();

  for (const entry of bundle?.entry ?? []) {
    const resource = entry.resource;
    if (!resource || resource.resourceType !== "Appointment") continue;

    const appointment = resource as fhir5.Appointment;
    const isoDate = appointmentStartToIsoDate(appointment.start);
    if (!isoDate || !isAppointmentDateWithinPeriod(isoDate, period)) continue;

    const patientRef = appointment.participant?.find((p) =>
      p.actor?.reference?.startsWith("Patient/"),
    )?.actor?.reference;

    const patientId = patientRef ? patientIdFromReference(patientRef) : undefined;
    if (patientId) ids.add(patientId);
  }

  return ids;
}
